module.exports = __webpack_public_path__ + "img/oaknest-5.1b5050b8.jpeg";